import L from "leaflet";

const iconCache = {};

export const createIcon = (icon) => {
  let iconUrl = typeof icon === "string" ? icon.trim() : icon?.url;

  if (!iconUrl || iconUrl.endsWith("/") || iconUrl.endsWith("/null") || iconUrl.endsWith("/undefined")) {
    iconUrl = "https://maps.gstatic.com/mapfiles/ms2/micons/blue-dot.png";
  }

  if (!iconCache[iconUrl]) {
    iconCache[iconUrl] = L.icon({
      iconUrl,
      iconSize: (typeof icon === "object" && icon?.size) || [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -28],
    });
  }

  return iconCache[iconUrl];
};
